import React from 'react';
import { Tooltip } from 'antd';

export function toColorInputValue(value: unknown): string {
  if (typeof value === 'string' && /^#[0-9a-fA-F]{6}$/i.test(value.trim())) {
    return value.trim();
  }
  return '#000000';
}

export function hasRibbonColorValue(value: unknown): boolean {
  return typeof value === 'string' && /^#[0-9a-fA-F]{3,8}$/i.test(value.trim());
}

type Props = {
  value?: string;
  onChange?: (value: string) => void;
  title: string;
  icon: React.ReactNode;
};

export const RibbonColorSwatch: React.FC<Props> = ({ value, onChange, title, icon }) => {
  const hasColor = hasRibbonColorValue(value);
  const display = hasColor ? toColorInputValue(value) : '#000000';

  return (
    <Tooltip title={title} placement="top" mouseEnterDelay={0.3}>
      <label
        className={`word-ribbon-color-label${hasColor ? ' word-ribbon-color-label--active' : ''}`}
      >
        <input
          type="color"
          className="word-ribbon-color-input-hidden"
          aria-label={title}
          value={display}
          onChange={(e) => onChange?.(e.target.value)}
        />
        <span className="word-ribbon-color-swatch" aria-hidden>
          {icon}
          <span
            className="word-ribbon-color-bar"
            style={hasColor ? { background: display } : undefined}
          />
        </span>
      </label>
    </Tooltip>
  );
};
